import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const Logo = ({ size = 40 }) => (
    <img
        src="/logo-mark.png"
        alt="ANG Engenharia"
        width={size}
        height={size}
        className="rounded-lg"
        style={{ width: size, height: size, objectFit: "cover" }}
    />
);

export const LogoFull = ({ width = 150 }) => (
    <img
        src="/logo-full.jpg"
        alt="ANG Engenharia — Elétrica e T.I"
        width={width}
        className="rounded-xl"
        style={{ width }}
    />
);

export const Eyebrow = () => null;

export const Zap = ({ className = "w-4 h-4" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
        <path d="M13 2 L4.5 13.5 h5.5 L9 22 l9.5 -11.5 h-5.5 L13 2 z" />
    </svg>
);
